// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (min-width: 0px) and (max-width: 767px) {
  .video_list_container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin: 0 auto;
  }

  .video_list {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;
  }

  .video_thumbnail {
    width: 100%;
    height: auto;
    cursor: pointer;
    border-radius: 10px 10px 0 0;
  }

  .video_card {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    cursor: pointer;
    border-radius: 10px;
    box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);
  }

  .video_title_container {
    display: flex;
    flex-direction: column;
    padding: 10px;
    width: 100%;
  }

  .video_title {
    font-size: 14px;
    font-family: "Lato";
    font-weight: 600;
    text-align: left;
  }

  .viewed_count_in_videos {
    font-size: 12px;
    font-family: "Lato";
    font-weight: 300;
    padding-top: 10px;
  }
  .featured_video_component {
    width: 100% !important;
  }
  .featured_video_thumbnail_overlay_content {
    width: 82% !important;
  }

  .featured_story_video_container {
    display: none !important;
  }
  .featured_video_content {
    width: 95%;
  }

  .featured_story_video_title {
    color: var(--background-theme-color);
  }
  .featured_video_content_title_wrapper {
    row-gap: 10px !important;
    padding: 20px 0 20px 0;
  }
  .video_list_skeleton {
    display: grid;
    grid-template-columns: 100%;
    gap: 30px;
    margin-top: 10px;
    width: 100%;
  }
  .video_list_skeleton_image {
    width: 100% !important;
    min-height: 200px !important;
  }
  .featured_videos_thumbnail_overlay_play_icon {
    width: 50px !important;
    height: 50px !important;
  }
  .feature_video_text {
    font-size: 10px !important;
  }
  .join_whatsapp_channel_videos {
    display: none;
  }
  .videos_subscribe_button_wrapper {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/screen_767/screen_767_videos.css"],"names":[],"mappings":"AAAA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,oDAAoD;EACtD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,WAAW;EACb;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;EACA;IACE,UAAU;EACZ;;EAEA;IACE,oCAAoC;EACtC;EACA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .video_list_container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .video_list {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n    gap: 30px;\n  }\n\n  .video_thumbnail {\n    width: 100%;\n    height: auto;\n    cursor: pointer;\n    border-radius: 10px 10px 0 0;\n  }\n\n  .video_card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    cursor: pointer;\n    border-radius: 10px;\n    box-shadow: 5px 5px 15px 0px rgba(0, 101, 204, 0.15);\n  }\n\n  .video_title_container {\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    width: 100%;\n  }\n\n  .video_title {\n    font-size: 14px;\n    font-family: \"Lato\";\n    font-weight: 600;\n    text-align: left;\n  }\n\n  .viewed_count_in_videos {\n    font-size: 12px;\n    font-family: \"Lato\";\n    font-weight: 300;\n    padding-top: 10px;\n  }\n  .featured_video_component {\n    width: 100% !important;\n  }\n  .featured_video_thumbnail_overlay_content {\n    width: 82% !important;\n  }\n\n  .featured_story_video_container {\n    display: none !important;\n  }\n  .featured_video_content {\n    width: 95%;\n  }\n\n  .featured_story_video_title {\n    color: var(--background-theme-color);\n  }\n  .featured_video_content_title_wrapper {\n    row-gap: 10px !important;\n    padding: 20px 0 20px 0;\n  }\n  .video_list_skeleton {\n    display: grid;\n    grid-template-columns: 100%;\n    gap: 30px;\n    margin-top: 10px;\n    width: 100%;\n  }\n  .video_list_skeleton_image {\n    width: 100% !important;\n    min-height: 200px !important;\n  }\n  .featured_videos_thumbnail_overlay_play_icon {\n    width: 50px !important;\n    height: 50px !important;\n  }\n  .feature_video_text {\n    font-size: 10px !important;\n  }\n  .join_whatsapp_channel_videos {\n    display: none;\n  }\n  .videos_subscribe_button_wrapper {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
